<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Bar Management</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="card2" style="margin-top: 1rem">
        <v-card-title class="py-4 px-4">
          <v-row align="center" no-gutters>
            <!-- Title Section -->
            <v-col cols="12" sm="12" md="3" lg="3" xl="3" class="d-flex align-center pb-3 pb-md-0">
              <v-icon color="blue-grey darken-2 mr-5" size="28">mdi-dock-top</v-icon>
              <div>
                <h3 class="text-h6 mb-1">Bar Configuration</h3>
                <p class="text-caption text-grey-darken-1 mb-0">Configure the bar shown on customer screens</p>
              </div>
            </v-col>

            <!-- Controls Section -->
            <v-col cols="12" sm="12" md="9" lg="9" xl="9">
              <v-row align="center" justify="end" no-gutters>
                <v-col cols="12" sm="5" md="5" lg="5" xl="5">
                  <v-text-field v-model="searchText" prepend-inner-icon="mdi-magnify" placeholder="Search" hide-details variant="outlined" rounded class="search-field"></v-text-field>
                </v-col>

                <v-col v-if="permissions.add" cols="auto" class="ml-2 ml-sm-3">
                  <v-btn color="primary" dark class="btn-layout" @click="openAddDialog">
                    <v-icon left>mdi-plus</v-icon>
                    Bar
                  </v-btn>
                </v-col>

                <v-col cols="auto" class="ml-2">
                  <v-btn icon class="btn-filter" small elevation="0" @click="toggleFilter">
                    <v-icon size="20" color="white">mdi-filter-variant</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-item>
          <div class="table-container">
            <v-data-table-server :items-per-page="options.itemsPerPage" :items-length="searchTotalTable" v-model:options="options" :items="items" class="my-data-table modern-table" fixed-header>
              <template v-slot:headers>
                <tr>
                  <th style="text-align: center; width: 95px; background-color: #f5f5f5">
                    {{ $t('no') }}
                  </th>
                  <th style="text-align: left; width: 300px; background-color: #f5f5f5">Name</th>
                  <th style="text-align: left; width: 600px; background-color: #f5f5f5">Bar Name</th>
                  <th style="text-align: center; width: 260px; background-color: #f5f5f5">Button Name</th>
                  <th style="text-align: center; width: 260px; background-color: #f5f5f5">Action Type</th>
                  <th style="text-align: center; width: 200px; background-color: #f5f5f5">Target Group</th>
                  <th style="text-align: center; width: 200px; background-color: #f5f5f5">Segment</th>
                  <th style="text-align: center; width: 200px; background-color: #f5f5f5">Wealth Membership</th>
                  <th style="text-align: center; width: 320px; background-color: #f5f5f5">Conditions</th>
                  <th style="text-align: center; background-color: #f5f5f5">Priority</th>
                  <th style="text-align: center; width: 400px; background-color: #f5f5f5">Effective Start Date</th>
                  <th style="text-align: center; width: 400px; background-color: #f5f5f5">Effective End Date</th>
                  <th style="text-align: center; width: 300px; background-color: #f5f5f5">Create Date</th>
                  <th class="sticky-status" style="text-align: center; width: 230px; background-color: #f5f5f5">Status</th>
                  <th class="sticky-repeat" style="text-align: center; width: 230px; background-color: #f5f5f5">Repeat Flag</th>
                  <th class="sticky-action" style="text-align: center; width: 230px; background-color: #f5f5f5">Action</th>
                </tr>
              </template>

              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">
                    <div class="d-flex flex-column align-center gap-1">
                      <span>{{ item.number }}</span>
                      <v-chip v-if="item.defaultFlag" color="primary" size="x-small" variant="tonal">
                        <v-icon size="10" class="mr-1">mdi-star</v-icon>
                        Default
                      </v-chip>
                    </div>
                  </td>

                  <td>
                    <div class="d-flex align-center ga-2">
                      <v-avatar v-if="isSafeImageUrl(item.barIcon)" size="28" rounded="sm">
                        <v-img :src="item.barIcon" alt="Bar Icon" cover />
                      </v-avatar>
                      <span class="message-text">
                        <v-tooltip activator="parent" location="top" max-width="400">{{ item.name }}</v-tooltip>
                        {{ item.name }}
                      </span>
                    </div>
                  </td>

                  <td>
                    <div class="message-multilang">
                      <div v-if="item.barNameThai" class="message-box message-box-thai">
                        <div class="message-lang-header"><span class="lang-label">TH</span></div>
                        <span class="message-text">
                          <v-tooltip activator="parent" location="top" max-width="400">{{ item.barNameThai }}</v-tooltip>
                          {{ item.barNameThai }}
                        </span>
                      </div>
                      <div v-if="item.barNameEnglish" class="message-box message-box-english">
                        <div class="message-lang-header"><span class="lang-label">EN</span></div>
                        <span class="message-text">
                          <v-tooltip activator="parent" location="top" max-width="400">{{ item.barNameEnglish }}</v-tooltip>
                          {{ item.barNameEnglish }}
                        </span>
                      </div>
                      <div v-if="item.barNameChinese" class="message-box message-box-chinese">
                        <div class="message-lang-header"><span class="lang-label">CN</span></div>
                        <span class="message-text">
                          <v-tooltip activator="parent" location="top" max-width="400">{{ item.barNameChinese }}</v-tooltip>
                          {{ item.barNameChinese }}
                        </span>
                      </div>
                      <span v-if="!item.barNameThai && !item.barNameEnglish && !item.barNameChinese" class="text-grey">No bar name</span>
                    </div>
                  </td>

                  <td style="text-align: center">
                    <!-- One data-chip per language, tagged TH / EN / CN, instead of one chip holding
                         "thai / english / chinese" glued together: they are three separate values, and
                         the joined string hit the chip's ellipsis long before the second name started.
                         Same shape as the Segment and Wealth Membership columns below. -->
                    <div v-if="item.hasButton" class="data-container">
                      <v-chip
                        v-for="entry in item.buttonNames"
                        :key="entry.lang"
                        size="small"
                        variant="tonal"
                        color="grey"
                        class="data-chip bm-btn-name-chip ma-1"
                      >
                        <v-tooltip activator="parent" location="top" max-width="400">{{ entry.lang }} — {{ entry.name }}</v-tooltip>
                        <span class="lang-label mr-1">{{ entry.lang }}</span>
                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block">{{ entry.name }}</span>
                      </v-chip>
                      <!-- hasButton on but every name blank — nothing to chip -->
                      <span v-if="!item.buttonNames.length" class="text-grey">—</span>
                    </div>
                    <v-icon v-else color="grey-lighten-2" class="icon-inactive" size="20">mdi-check-circle</v-icon>
                  </td>

                  <td style="text-align: center">
                    <!-- Clicking the chip copies the target URL. The column only has room for the
                         word "URL", so without this the address could be read off the tooltip but
                         never taken out of the page. Passing @click is also what makes VChip render
                         as clickable (useLink().isClickable checks for an onClick attr), so the
                         pointer cursor is the affordance — the tooltip stays the URL and nothing else. -->
                    <v-chip
                      v-if="item.actionType === 'Url'"
                      color="info"
                      size="small"
                      variant="tonal"
                      @click="copyActionUrl(item.actionUrl)"
                    >
                      <v-tooltip activator="parent" location="top" max-width="400">{{ item.actionUrl }}</v-tooltip>
                      <v-icon size="14" class="mr-1">mdi-link-variant</v-icon>
                      URL
                    </v-chip>
                    <v-chip v-else-if="item.actionType === 'TaxPlanning'" color="primary" size="small" variant="tonal">
                      <v-icon size="14" class="mr-1">mdi-calculator-variant</v-icon>
                      Tax Planning
                    </v-chip>
                    <span v-else class="text-grey">—</span>
                  </td>

                  <td style="text-align: center">
                    <span>{{ getTargetGroupName(item.targetGroup) }}</span>
                    <span v-if="isCifTargetGroup(item.targetGroup) && item.cifCount > 0" class="ml-1 text-caption text-grey"> ({{ item.cifCount }} CIFs) </span>
                    <!-- The CIF list is only used once imported (BarManagementBAL.MatchesTargetGroup) — until then nobody sees the bar -->
                    <div v-if="isCifTargetGroup(item.targetGroup) && item.cifStatus === 'Processing'">
                      <v-chip size="x-small" color="warning" variant="tonal">Importing CIFs…</v-chip>
                    </div>
                    <div v-else-if="isCifTargetGroup(item.targetGroup) && item.cifStatus === 'Error'">
                      <v-chip size="x-small" color="error" variant="tonal">
                        CIF import failed
                        <v-tooltip activator="parent" location="top" max-width="320">The CIF list could not be imported (or the file was uploaded before CIF import existed). Remove the file and upload it again.</v-tooltip>
                      </v-chip>
                    </div>
                  </td>

                  <td style="text-align: center">
                    <div class="data-container">
                      <v-chip v-for="(seg, index) in item.segment" :key="index" size="small" variant="tonal" color="grey" class="data-chip ma-1" style="max-width: 150px">
                        <v-tooltip activator="parent" location="top">{{ seg }}</v-tooltip>
                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block">{{ seg }}</span>
                      </v-chip>
                    </div>
                  </td>

                  <td style="text-align: center">
                    <div class="data-container">
                      <v-chip v-for="(flag, index) in item.wealthMembership" :key="index" size="small" variant="tonal" color="grey" class="data-chip ma-1" style="max-width: 150px">
                        <v-tooltip activator="parent" location="top">{{ getWealthMembershipName(flag) }}</v-tooltip>
                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block">{{ getWealthMembershipName(flag) }}</span>
                      </v-chip>
                    </div>
                  </td>

                  <td style="text-align: center">
                    <div v-if="item.conditionSummary" class="data-container">
                      <v-chip size="small" variant="tonal" color="deep-purple" class="data-chip ma-1" style="max-width: 260px">
                        <v-tooltip activator="parent" location="top" max-width="400">{{ item.conditionSummary }}</v-tooltip>
                        <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block">{{ item.conditionSummary }}</span>
                      </v-chip>
                    </div>
                    <span v-else class="text-grey">—</span>
                  </td>

                  <td style="text-align: center">{{ item.priority }}</td>
                  <td style="text-align: center">{{ item.effStartDate }}</td>
                  <td style="text-align: center">{{ item.effEndDate }}</td>
                  <td style="text-align: center">{{ item.createDate }}</td>

                  <td class="sticky-status" style="text-align: center">
                    <v-chip :color="item.status === 'Active' ? 'success' : 'error'" size="small">
                      {{ item.status }}
                    </v-chip>
                  </td>

                  <td class="sticky-repeat" style="text-align: center">
                    <v-icon :color="item.repeatFlag ? 'success' : 'grey-lighten-2'" :class="{ 'icon-active': item.repeatFlag, 'icon-inactive': !item.repeatFlag }" size="20"> mdi-check-circle </v-icon>
                  </td>

                  <td class="sticky-action" style="text-align: center">
                    <div class="action-group" style="justify-content: center; display: flex">
                      <v-btn variant="text" density="comfortable" @click="Edit(item)" class="action-btn edit-btn" icon>
                        <v-icon size="18">{{ permissions.edit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                        <v-tooltip activator="parent" location="top">{{ permissions.edit ? 'Edit' : 'View' }}</v-tooltip>
                      </v-btn>
                      <v-btn v-if="permissions.delete" variant="text" density="comfortable" @click="DeleteBar(item.id)" class="action-btn delete-btn" icon>
                        <v-icon size="18">mdi-delete-outline</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-card-item>
      </v-card>
    </v-container>

    <!-- Add/Edit Bar Dialog -->
    <v-dialog v-model="addDialog" max-width="640" persistent>
      <v-card class="add-bar-dialog" elevation="0">
        <!-- Header stays fixed above the scrolling body -->
        <div class="bm-header">
          <div class="bm-header-text">
            <div class="bm-title">{{ isEditMode ? (permissions.edit ? 'Edit Bar Name' : 'View Bar Name') : 'Add Bar Name' }}</div>
          </div>
          <button type="button" class="bm-close" aria-label="Close" @click="closeAddDialog">
            <v-icon size="16">mdi-close</v-icon>
          </button>
        </div>

        <!-- Body is the only scrolling area; header and footer never move -->
        <div class="bm-body">
          <v-form ref="addForm" v-model="formValid">
            <!-- Name -->
            <div class="bm-group">
              <div class="bm-label">Name <span class="bm-req">*</span></div>
              <v-text-field
                v-model="formData.name"
                placeholder='Enter proactive message name (e.g., "Tax Planning Banner - Genie Screen")'
                variant="outlined"
                density="compact"
                hide-details="auto"
                class="bm-field"
                :rules="[rules.required]"
              ></v-text-field>
            </div>

            <!-- Bar Icon (optional): upload returns the public URL into formData.barIcon; SAVE persists it -->
            <div class="bm-group">
              <div class="bm-section-header">Bar Icon <span class="text-caption text-medium-emphasis">(optional)</span></div>
              <div class="bm-card">
                <div class="d-flex align-center flex-wrap ga-3">
                  <v-avatar size="56" rounded="lg" color="grey-lighten-3">
                    <v-img v-if="safeBarIconUrl" :src="safeBarIconUrl" alt="Bar Icon" cover />
                    <v-icon v-else size="28" color="grey">mdi-image-outline</v-icon>
                  </v-avatar>
                  <v-btn v-if="!isViewOnly" variant="outlined" color="#4C2A75" rounded="lg" prepend-icon="mdi-upload" :loading="barIconUploading" @click="triggerBarIconUpload">
                    Upload Icon
                  </v-btn>
                  <v-btn v-if="formData.barIcon && !isViewOnly" variant="text" color="error" :disabled="barIconUploading" @click="formData.barIcon = ''"> Remove </v-btn>
                  <span class="text-caption text-medium-emphasis">Image file, max 10MB</span>
                </div>
                <input ref="barIconInput" type="file" accept="image/*" style="display: none" aria-label="Upload Bar Icon" @change="handleBarIconUpload" />
              </div>
            </div>

            <!-- Bar Name: one row per language, grouped in a grey card -->
            <div class="bm-group">
              <div class="bm-section-header">Bar Name</div>
              <div class="bm-card">
                <!-- Each placeholder is a sample written in that field's own language, per the design -->
                <div class="bm-lang-field">
                  <div class="bm-lang-label">🇹🇭 In Thai</div>
                  <v-text-field v-model="formData.barNameThai" placeholder="ผลการวางแผนภาษีพร้อมแล้ว ดูตัวเลือกที่ดีที่สุด" variant="outlined" density="compact" hide-details="auto" class="bm-field" :rules="[rules.required]"></v-text-field>
                </div>
                <div class="bm-lang-field">
                  <div class="bm-lang-label">🇬🇧 In English</div>
                  <v-text-field v-model="formData.barNameEnglish" placeholder="Your tax planning results are ready. View your best options." variant="outlined" density="compact" hide-details="auto" class="bm-field" :rules="[rules.required]"></v-text-field>
                </div>
                <div class="bm-lang-field">
                  <div class="bm-lang-label">🇨🇳 In Chinese</div>
                  <v-text-field v-model="formData.barNameChinese" placeholder="您的税务规划结果已 ready，查看最佳选择" variant="outlined" density="compact" hide-details="auto" class="bm-field" :rules="[rules.required]"></v-text-field>
                </div>
              </div>
            </div>

            <!-- Button Name: the checkbox gates the three inputs, which stay visible but dimmed while off -->
            <div class="bm-group">
              <div class="bm-section-header">Button Name</div>
              <div class="bm-card">
                <v-checkbox v-model="formData.hasButton" label="Button Name" color="#4C2A75" density="compact" hide-details class="bm-check bm-check-strong bm-enable-row"></v-checkbox>

                <div class="bm-lang-sub" :class="{ 'is-off': !formData.hasButton }">
                  <div class="bm-lang-field">
                    <div class="bm-lang-label">🇹🇭 Button Name (Thai)</div>
                    <v-text-field
                      v-model="formData.buttonNameThai"
                      placeholder="ดูแผนภาษี"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="bm-field"
                      :disabled="!formData.hasButton"
                      :rules="buttonNameRules"
                    ></v-text-field>
                  </div>
                  <div class="bm-lang-field">
                    <div class="bm-lang-label">🇬🇧 Button Name (English)</div>
                    <v-text-field
                      v-model="formData.buttonNameEnglish"
                      placeholder="View Tax Plan"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="bm-field"
                      :disabled="!formData.hasButton"
                      :rules="buttonNameRules"
                    ></v-text-field>
                  </div>
                  <div class="bm-lang-field">
                    <div class="bm-lang-label">🇨🇳 Button Name (Chinese)</div>
                    <v-text-field
                      v-model="formData.buttonNameChinese"
                      placeholder="查看税务规划"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="bm-field"
                      :disabled="!formData.hasButton"
                      :rules="buttonNameRules"
                    ></v-text-field>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Type: two check-style options. setActionType() keeps them mutually
                 exclusive and clears the choice when the selected one is clicked again. -->
            <div class="bm-group">
              <div class="bm-section-header">Action Type</div>
              <div class="bm-card">
                <div class="bm-hint">Choose one</div>

                <div class="bm-action-row">
                  <v-checkbox
                    :model-value="formData.actionType === 'Url'"
                    label="URL"
                    color="#4C2A75"
                    density="compact"
                    hide-details
                    class="bm-check"
                    @update:model-value="setActionType('Url')"
                  ></v-checkbox>
                  <v-checkbox
                    :model-value="formData.actionType === 'TaxPlanning'"
                    label="Tax Planning"
                    color="#4C2A75"
                    density="compact"
                    hide-details
                    class="bm-check"
                    @update:model-value="setActionType('TaxPlanning')"
                  ></v-checkbox>
                </div>

                <!-- Target URL stays on screen and is dimmed until URL is picked, like Button Name.
                     Only the Tax Planning note is conditional. -->
                <div class="bm-lang-sub bm-action-detail" :class="{ 'is-off': !isUrlAction }">
                  <div class="bm-lang-field">
                    <div class="bm-lang-label">🔗 Target URL</div>
                    <v-text-field
                      ref="actionUrlField"
                      v-model="actionUrlInput"
                      placeholder="Enter target URL, e.g., https://..."
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="bm-field"
                      :disabled="!isUrlAction"
                      :rules="actionUrlRules"
                    ></v-text-field>
                  </div>
                </div>

                <div v-if="formData.actionType === 'TaxPlanning'" class="bm-tax-note">✓ Action will launch the <strong>Tax Planning</strong> feature module directly.</div>
              </div>
            </div>

            <!-- Priority -->
            <div class="bm-group">
              <div class="bm-label">Priority</div>
              <v-text-field
                v-model="formData.priority"
                type="number"
                min="0"
                step="1"
                placeholder="Enter priority order, e.g., 1, 2, 3"
                variant="outlined"
                density="compact"
                hide-details="auto"
                class="bm-field bm-field-narrow"
                :rules="[rules.priority]"
              ></v-text-field>
            </div>

            <!-- Effective dates sit side by side -->
            <div class="bm-group bm-grid-2">
              <div>
                <div class="bm-label">Effective Start Date</div>
                <v-text-field v-model="formData.effectiveStartDate" type="date" variant="outlined" density="compact" hide-details="auto" class="bm-field bm-date-field" :rules="[rules.required]">
                  <template #append-inner><span class="bm-cal-ic">📅</span></template>
                </v-text-field>
              </div>
              <div>
                <div class="bm-label">Effective End Date</div>
                <v-text-field v-model="formData.effectiveEndDate" type="date" variant="outlined" density="compact" hide-details="auto" class="bm-field bm-date-field" clearable :rules="endDateRules">
                  <template #append-inner><span class="bm-cal-ic">📅</span></template>
                </v-text-field>
              </div>
            </div>

            <!-- Target Group -->
            <div class="bm-group">
              <div class="bm-card">
                <div class="bm-section-header bm-tg-header">Target Group</div>

                <div class="bm-sub-header">1. Primary Segment</div>
                <!-- The tiles behave as one radio group: a click writes formData.targetGroup.
                     The whole group is locked on "All" while this bar is the default, since a
                     fallback aimed at a subset would leave the people it exists for with nothing. -->
                <div class="bm-seg-grid" :class="{ 'is-locked': formData.defaultFlag }" role="radiogroup" aria-label="Primary Segment">
                  <div
                    v-for="segment in primarySegments"
                    :key="segment.value"
                    class="bm-seg-item"
                    :class="{ 'is-selected': formData.targetGroup === segment.value }"
                    role="radio"
                    :tabindex="formData.defaultFlag ? -1 : 0"
                    :aria-checked="formData.targetGroup === segment.value"
                    :aria-disabled="formData.defaultFlag"
                    @click="formData.targetGroup = segment.value"
                    @keydown.enter.prevent="formData.targetGroup = segment.value"
                    @keydown.space.prevent="formData.targetGroup = segment.value"
                  >
                    <span class="bm-radio-dot"></span>
                    <span class="bm-radio-text">{{ segment.label }}</span>
                  </div>
                  <v-tooltip v-if="formData.defaultFlag" activator="parent" location="top">The default bar targets everyone — turn Default off to change this</v-tooltip>
                </div>

                <!-- Persona reveals the two audience selects -->
                <div v-if="formData.targetGroup === 'Persona'" class="bm-grid-2">
                  <div>
                    <div class="bm-label">Segment</div>
                    <v-select
                      v-model="formData.segment"
                      :items="segmentOptions"
                      item-title="name"
                      item-value="valueString"
                      placeholder="Select Segment"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="bm-field"
                      multiple
                      chips
                    ></v-select>
                  </div>
                  <div>
                    <div class="bm-label">Wealth Membership</div>
                    <v-select
                      v-model="formData.wealthMembership"
                      :items="wealthMembershipOptions"
                      item-title="name"
                      item-value="valueString"
                      placeholder="Select Wealth Membership"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      class="bm-field"
                      multiple
                      chips
                    ></v-select>
                  </div>
                </div>

                <!-- CIF List / Except CIF reveal the upload tools and the uploaded-file table -->
                <div v-if="isCifTargetGroup(formData.targetGroup)">
                  <div class="bm-cif-actions">
                    <v-btn variant="flat" class="bm-excel-btn bm-excel-upload" @click="triggerFileUpload">
                      <v-icon size="16" class="mr-2">mdi-microsoft-excel</v-icon>
                      UPLOAD FILE
                    </v-btn>
                    <v-btn variant="flat" class="bm-excel-btn bm-excel-download" @click="downloadTemplate">
                      <v-icon size="16" class="mr-2">mdi-microsoft-excel</v-icon>
                      DOWNLOAD TEMPLATE
                    </v-btn>
                  </div>

                  <input ref="fileInput" type="file" accept=".csv,.xlsx,.xls" style="display: none" @change="handleFileUpload" />

                  <div v-if="hasUploadedFiles" class="bm-file-table">
                    <div class="bm-file-table-head">
                      <v-icon size="16" color="#4C2A75">mdi-file-table</v-icon>
                      Uploaded CIF Files ({{ totalUploadedFiles }}) - Total CIF Codes: {{ totalCifCodes }}
                    </div>
                    <!-- Four columns, sized to the ~550px the modal leaves inside the grey card
                         (640 - 56 body padding - 32 card padding). The name column takes whatever
                         the three fixed ones do not, and truncates. -->
                    <v-table class="bm-file-rows" density="compact">
                      <thead>
                        <tr>
                          <th class="text-left">File Name</th>
                          <th class="text-center" style="width: 62px">CIF</th>
                          <th class="text-center" style="width: 100px">Uploaded</th>
                          <th class="text-center" style="width: 168px">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(file, index) in uploadedFiles" :key="index">
                          <td>
                            <div class="bm-file-cell">
                              <v-icon size="16" color="success">mdi-file-document</v-icon>
                              <div class="bm-file-meta">
                                <div class="bm-file-name">
                                  <v-tooltip activator="parent" location="top" max-width="400">{{ file.fileName }}</v-tooltip>
                                  {{ file.fileName }}
                                </div>
                                <div class="bm-file-sub">{{ formatFileSize(file.fileSize) }}</div>
                              </div>
                            </div>
                          </td>
                          <td class="text-center">
                            <v-chip size="x-small" color="#4C2A75" variant="outlined">{{ file.cifCount }}</v-chip>
                          </td>
                          <td class="text-center">
                            <div class="bm-file-sub">
                              <v-tooltip activator="parent" location="top">{{ formatUploadDate(file.uploadDate) }}</v-tooltip>
                              {{ formatUploadDay(file.uploadDate) }}
                            </div>
                          </td>
                          <td class="text-center">
                            <div class="bm-file-actions">
                              <v-btn variant="outlined" color="#4C2A75" size="x-small" @click="downloadCifFile(file)">
                                <v-icon size="14" class="mr-1">mdi-download</v-icon>
                                Download
                              </v-btn>
                              <v-btn variant="outlined" color="error" size="x-small" @click="removeCifFile(index)">
                                <v-icon size="14" class="mr-1">mdi-delete</v-icon>
                                Delete
                              </v-btn>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </div>
                </div>

                <div class="bm-dashed-divider"></div>

                <div class="bm-sub-header">2. Refinement Conditions (AND Logic)</div>

                <v-checkbox v-model="formData.taxConditionEnabled" label="Tax Planning" color="#4C2A75" density="compact" hide-details class="bm-check bm-check-strong bm-enable-row"></v-checkbox>

                <!-- The three modes stay on screen but are dimmed and inert until the checkbox above is ticked.
                     Each mode's extra inputs are only rendered while that mode is picked, so their
                     requiredList rules never block the form for a mode the user is not using.

                     ⚠️ Deliberately a plain <div> and NOT <v-radio-group>. Every Vuetify selection control
                     (v-checkbox, v-radio, and the v-checkbox-btn VSelect draws in its menu) injects
                     VSelectionControlGroupSymbol and, when it finds a group, reads and writes the GROUP's
                     model instead of its own — see useSelectionControl() in VSelectionControl.js. A
                     radio group wrapped around these rows therefore hijacked everything nested inside a
                     mode's body: the Current State boxes never ticked and clicking one overwrote
                     taxConditionMode (which closed the body it was in), and the tick in the Tax Year menu
                     stayed blank because its model resolved to the mode string, not isSelected. Teleporting
                     the menu to <body> does not help — provide/inject follows the component tree, not the DOM.
                     Each v-radio carries its own v-model now; the shared name keeps them one native
                     radio group so arrow-key navigation still works. -->
                <div class="bm-status-list" :class="{ 'is-off': !formData.taxConditionEnabled }" role="radiogroup">
                  <div v-for="mode in taxConditionModes" :key="mode.value" class="bm-status-item" :class="{ 'is-selected': formData.taxConditionMode === mode.value }">
                    <!-- The whole head row selects the mode, not just the radio itself -->
                    <div class="bm-status-head" @click="formData.taxConditionMode = mode.value">
                      <v-radio
                        v-model="formData.taxConditionMode"
                        :label="mode.label"
                        :value="mode.value"
                        :disabled="!formData.taxConditionEnabled"
                        name="bm-tax-condition-mode"
                        color="#4C2A75"
                      ></v-radio>
                    </div>

                    <div v-if="formData.taxConditionEnabled && formData.taxConditionMode === mode.value && mode.value !== 'Never'" class="bm-status-body">
                      <div class="bm-label">Tax Year</div>
                      <v-select
                        v-model="formData.taxConditionYears"
                        :items="taxYearOptions"
                        item-title="name"
                        item-value="valueString"
                        placeholder="Select Tax Year(s)"
                        variant="outlined"
                        density="compact"
                        hide-details="auto"
                        class="bm-field"
                        multiple
                        chips
                        :rules="[rules.requiredList]"
                        :menu-props="{ contentClass: 'bm-year-menu' }"
                      ></v-select>

                      <!-- Current State is a plain checkbox list, not a dropdown, per the design -->
                      <template v-if="mode.value === 'PendingState'">
                        <div class="bm-label bm-label-spaced">Current State</div>
                        <div class="bm-checkbox-list">
                          <v-checkbox
                            v-for="state in conditionStateOptions"
                            :key="state.valueString"
                            v-model="formData.taxConditionStates"
                            :label="state.name"
                            :value="state.valueString"
                            color="#4C2A75"
                            density="compact"
                            hide-details
                            class="bm-check"
                          ></v-checkbox>
                        </div>
                        <!-- v-checkbox cannot carry a rule, so the empty case is called out here.
                             The backend rejects it too (BarManagementBAL.Validate). -->
                        <div v-if="formData.taxConditionStates.length === 0" class="bm-field-error">Please select at least one</div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-form>
        </div>

        <!-- Footer is pinned below the scrolling body -->
        <div class="bm-footer">
          <div class="bm-toggles">
            <!-- Each label names the state the switch is currently in. The design shows
                 "Enable / No Repeat / No Default" because that is what these read at their
                 default position (on / off / off) — a fixed "No Repeat" on a switch you turn ON
                 to enable repeating would say the opposite of what it does.

                 Default is the flag that drives the other two settings: switching it on turns
                 Enable on and pins Target Group to All. Enable is then greyed out and held in the
                 on position until Default is switched back off. -->
            <div class="bm-switch-wrap" :class="{ 'is-locked': formData.defaultFlag }">
              <v-switch v-model="formData.enableFlag" color="#4C2A75" :disabled="formData.defaultFlag" :label="formData.enableFlag ? 'Enable' : 'Disable'" hide-details density="compact" class="bm-switch"></v-switch>
              <v-tooltip v-if="formData.defaultFlag" activator="parent" location="top">The default bar stays enabled — turn Default off to change this</v-tooltip>
            </div>
            <v-switch v-model="formData.repeatFlag" color="#4C2A75" :label="formData.repeatFlag ? 'Repeat' : 'No Repeat'" hide-details density="compact" class="bm-switch"></v-switch>
            <v-switch v-model="formData.defaultFlag" color="#4C2A75" :label="formData.defaultFlag ? 'Default' : 'No Default'" hide-details density="compact" class="bm-switch"></v-switch>
          </div>

          <div class="bm-cta">
            <v-btn variant="flat" class="bm-btn bm-btn-cancel" @click="closeAddDialog">
              <v-icon size="16" class="mr-2">mdi-close</v-icon>
              {{ isViewOnly ? 'CLOSE' : 'CANCEL' }}
            </v-btn>
            <v-btn v-if="isEditMode ? permissions.edit : permissions.add" variant="flat" class="bm-btn bm-btn-save" @click="saveBar">
              <v-icon size="16" class="mr-2">mdi-content-save</v-icon>
              {{ isEditMode ? 'UPDATE' : 'SAVE' }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- Filter Sidebar -->
    <v-navigation-drawer v-model="filterDrawer" location="right" temporary width="400" class="filter-drawer">
      <v-card flat class="filter-card">
        <v-card-title class="filter-header d-flex align-center justify-space-between">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="primary">mdi-tune</v-icon>
            <span>Filter</span>
          </div>
          <v-btn icon small @click="filterDrawer = false" variant="text">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="filter-content">
          <!-- Status Filter -->
          <div class="filter-section">
            <h4 class="filter-section-title">Status</h4>
            <!-- "All" is the no-filter state: ticking it clears the two specific boxes, and
                 ticking either of those clears it. -->
            <v-checkbox v-model="filters.status.all" label="All" density="comfortable" class="filter-checkbox" @update:model-value="onStatusAll"></v-checkbox>
            <v-checkbox v-model="filters.status.active" label="Active" density="comfortable" class="filter-checkbox" @update:model-value="onStatusSpecific"></v-checkbox>
            <v-checkbox v-model="filters.status.inactive" label="Inactive" density="comfortable" class="filter-checkbox" @update:model-value="onStatusSpecific"></v-checkbox>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Target Group Filter -->
          <div class="filter-section">
            <h4 class="filter-section-title">Target Group</h4>
            <v-select
              v-model="filters.targetGroup"
              :items="targetGroupOptions"
              item-title="name"
              item-value="valueString"
              multiple
              chips
              label="Select Target Group"
              variant="outlined"
              rounded
              class="search-field custom-rounded"
              :menu-props="{ attach: 'body', zIndex: 9999, maxHeight: 300 }"
            ></v-select>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Action Type Filter -->
          <div class="filter-section">
            <h4 class="filter-section-title">Action Type</h4>
            <v-select
              v-model="filters.actionType"
              :items="actionTypeOptions"
              item-title="name"
              item-value="valueString"
              multiple
              chips
              label="Select Action Type"
              variant="outlined"
              rounded
              class="search-field custom-rounded"
              :menu-props="{ attach: 'body', zIndex: 9999, maxHeight: 300 }"
            ></v-select>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Segment Filter -->
          <div class="filter-section">
            <h4 class="filter-section-title">Segment</h4>
            <v-select
              v-model="filters.segment"
              :items="segmentOptions"
              item-title="name"
              item-value="valueString"
              multiple
              chips
              label="Select Segment"
              variant="outlined"
              rounded
              class="search-field custom-rounded"
              :menu-props="{ attach: 'body', zIndex: 9999, maxHeight: 300 }"
            ></v-select>
          </div>

          <v-divider class="my-4"></v-divider>

          <!-- Wealth Membership Filter -->
          <div class="filter-section">
            <h4 class="filter-section-title">Wealth Membership</h4>
            <v-select
              v-model="filters.wealthMembership"
              :items="wealthMembershipOptions"
              item-title="name"
              item-value="valueString"
              multiple
              chips
              label="Select Wealth Membership"
              variant="outlined"
              rounded
              class="search-field custom-rounded"
              :menu-props="{ attach: 'body', zIndex: 9999, maxHeight: 300 }"
            ></v-select>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="filter-section">
            <h4 class="filter-section-title">Effective Start Date</h4>
            <v-text-field v-model="filters.effectiveStartDate" type="date" label="Start Date" variant="outlined" rounded class="filter-field filter-rounded"></v-text-field>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="filter-section">
            <h4 class="filter-section-title">Effective End Date</h4>
            <v-text-field v-model="filters.effectiveEndDate" type="date" label="End Date" variant="outlined" rounded class="filter-field filter-rounded"></v-text-field>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="filter-actions pa-4">
          <v-btn color="grey" variant="outlined" @click="clearFilters" class="flex-fill"> Clear All </v-btn>
          <v-btn color="primary" @click="applyFilters" class="flex-fill ml-2"> Apply Filter </v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import checkPermissionTwo from '@/api/function.js';
import moment from 'moment';
import { taxConfigV2Api } from '@/services/taxConfigV2Api';

// The list, dialog and filter drawer follow views/ProactiveMessage.vue. The field set differs:
// a bar adds Button Name, Action Type, Except CIF and Refinement Conditions, and has no Screen
// or Continue Question.

// Button Name is stored one column per language; the list column chips them in this order.
const BUTTON_NAME_LANGS = [
  { lang: 'TH', field: 'buttonNameThai' },
  { lang: 'EN', field: 'buttonNameEnglish' },
  { lang: 'CN', field: 'buttonNameChinese' },
];

const EMPTY_FORM = () => ({
  name: '',
  barNameThai: '',
  barNameEnglish: '',
  barNameChinese: '',
  barIcon: '',
  hasButton: false,
  buttonNameThai: '',
  buttonNameEnglish: '',
  buttonNameChinese: '',
  actionType: 'None',
  actionUrl: '',
  priority: 1,
  effectiveStartDate: null,
  effectiveEndDate: null,
  targetGroup: 'All',
  segment: [],
  wealthMembership: [],
  cifFiles: [],
  // 🔴 These four fields exist for the screen only. They are folded into conditions[]
  //    on the way out and unfolded again on the way in — see buildConditions / parseConditions.
  taxConditionEnabled: false,
  taxConditionMode: 'Never',
  taxConditionYears: [],
  taxConditionStates: [],
  enableFlag: true,
  repeatFlag: false,
  defaultFlag: false,
});

export default {
  name: 'BarManagement',
  inject: ['flagNav', 'FontColorTitle'],
  mixins: [checkPermissionTwo],
  data: () => ({
    today: null,
    searchText: '',
    searchDebounceTimer: null,
    loading: false,
    dialog: false,
    filterDrawer: false,

    // Data table
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    items: [],
    searchTotalTable: 0,
    totalTable: 0,
    isFirst: true,
    isSearch: false,

    // Options from API
    segmentOptions: [],
    wealthMembershipOptions: [],
    actionTypeOptions: [],
    targetGroupOptions: [],
    conditionStateOptions: [],
    taxYearOptions: [],

    // Filter Sidebar
    filters: {
      status: {
        all: true,
        active: false,
        inactive: false,
      },
      targetGroup: [],
      actionType: [],
      segment: [],
      wealthMembership: [],
      effectiveStartDate: null,
      effectiveEndDate: null,
    },

    // Add/Edit Dialog
    addDialog: false,
    isEditMode: false,
    editingItemId: null,
    formValid: false,
    formData: EMPTY_FORM(),

    rules: {
      required: (value) => !!value || 'This field is required',
      requiredList: (value) => (Array.isArray(value) && value.length > 0) || 'Please select at least one',
      priority: (value) => {
        if (value === null || value === undefined || value === '') return 'This field is required';
        const priority = Number(value);
        return (Number.isInteger(priority) && priority >= 0) || 'Priority must be a whole number of 0 or greater';
      },
    },

    uploadedFiles: [],
    barIconUploading: false,
  }),
  computed: {
    // Only render http(s)/data-image URLs, so a stored value can never become a javascript: src
    safeBarIconUrl() {
      const raw = String(this.formData.barIcon || '').trim();
      return this.isSafeImageUrl(raw) ? raw : '';
    },
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('BarManagement');
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('BarManagement'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('BarManagement'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('BarManagement'),
      };
    },
    endDateRules() {
      // Optional: an empty end date means the bar never expires
      return [
        (value) => {
          if (!value || !this.formData.effectiveStartDate) return true;
          return value >= this.formData.effectiveStartDate || 'End Date must be on or after Start Date';
        },
      ];
    },
    // Required only while the button is switched on — otherwise the form fails validation
    // over fields nobody is using.
    buttonNameRules() {
      return [(value) => !this.formData.hasButton || !!value || 'This field is required'];
    },
    // Same idea for Target URL: the field is always rendered, so the rule only bites while
    // Action Type is 'Url'.
    isUrlAction() {
      return this.formData.actionType === 'Url';
    },
    actionUrlRules() {
      return [(value) => !this.isUrlAction || !!value || 'This field is required'];
    },
    // The Target URL box always shows what is in formData.actionUrl, whichever action is
    // picked: a URL typed earlier stays readable in the dimmed field, and the placeholder
    // stays on screen while the box is empty. saveBar() is what decides whether the value
    // is actually sent (only when the action is 'Url').
    actionUrlInput: {
      get() {
        return this.formData.actionUrl;
      },
      set(value) {
        this.formData.actionUrl = value;
      },
    },
    // Labels for the Primary Segment tiles. The values are the ones formData.targetGroup
    // is compared against elsewhere (isCifTargetGroup, saveBar, the defaultFlag watchers).
    primarySegments() {
      return [
        { value: 'All', label: 'All' },
        { value: 'Persona', label: 'Persona' },
        { value: 'CIF', label: 'CIF List' },
        { value: 'ExceptCIF', label: 'Except CIF' },
      ];
    },
    // The three refinement modes. The values are what buildConditions() writes into
    // conditions[].mode, so they must stay in sync with parseConditions().
    taxConditionModes() {
      return [
        { value: 'Never', label: 'Never Create Tax Planning' },
        { value: 'NeverInYears', label: 'Never Create in Specific Tax Year(s)' },
        { value: 'PendingState', label: 'Pending in Specific State' },
      ];
    },
    totalUploadedFiles() {
      return this.uploadedFiles.length;
    },
    totalCifCodes() {
      return this.uploadedFiles.reduce((total, file) => total + (file.cifCount || 0), 0);
    },
    hasUploadedFiles() {
      return this.uploadedFiles.length > 0;
    },
  },
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
    searchText: {
      handler() {
        this.debouncedSearch();
      },
    },
    // Default is the flag that leads: the default bar is the one shown to everyone who matched
    // nothing else, so it has to be enabled and aimed at everyone. Switching it on therefore
    // takes Enable and Target Group with it, and the screen locks both while it stays on — no
    // popups, because there is nothing for the user to decide or undo.
    'formData.defaultFlag': {
      handler(newValue) {
        if (newValue !== true) return;

        this.formData.enableFlag = true;
        this.formData.targetGroup = 'All';
      },
    },
  },
  mounted() {
    this.GetDate();
    this.GetOptions();
    this.GetTaxYears();
  },
  beforeUnmount() {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  },
  methods: {
    // ── list ──────────────────────────────────────────────────────────────
    Get() {
      let self = this;
      self.dialog = true;
      self.loading = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let request = {
        page: self.isSearch ? 1 : page,
        itemsPerPage: itemsPerPage !== -1 ? itemsPerPage : self.totalTable,
        searchText: self.searchText,
        sortBy: sortField,
        sortDesc: sortOrder ?? false,
        statusFilter: self.getStatusFilter(),
        targetGroupFilter: self.filters.targetGroup,
        actionTypeFilter: self.filters.actionType,
        segmentFilter: self.filters.segment,
        wealthMembershipFilter: self.filters.wealthMembership,
        effectiveStartDateFilter: self.filters.effectiveStartDate,
        effectiveEndDateFilter: self.filters.effectiveEndDate,
      };

      self.$call.GetTableBarManagement(
        request,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.searchTotalTable = dataResponse.data.totalCount;
            self.items = self.mapDataToItems(dataResponse.data.items);
            self.totalTable = self.isFirst ? dataResponse.data.totalCount : self.totalTable;
          } else {
            self.items = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.loading = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loading = false;
          self.isSearch = false;
          console.error('Error getting bars:', errorResource);
        }
      );
    },

    // navigator.clipboard is only handed out on a secure origin, and this console is served over
    // plain http on some environments, so the textarea + execCommand path is a real fallback here
    // rather than legacy-browser padding. Same shape as DiffDetailPanel.copyValue().
    async copyActionUrl(url) {
      if (!url) {
        this.$swal.fire({ icon: 'error', title: 'Error', text: 'This bar has no target URL to copy' });
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        document.body.removeChild(textarea);

        if (!copied) {
          this.$swal.fire({ icon: 'error', title: 'Copy failed', text: url });
          return;
        }
      }

      this.$swal.fire({
        icon: 'success',
        title: 'URL copied',
        text: url,
        toast: true,
        position: 'top-end',
        timer: 1800,
        showConfirmButton: false,
        timerProgressBar: true,
      });
    },

    mapDataToItems(apiData) {
      return (apiData || []).map((item, index) => ({
        number: (this.options.page - 1) * this.options.itemsPerPage + index + 1,
        id: item.id,
        name: item.name,
        barNameThai: item.barNameThai,
        barNameEnglish: item.barNameEnglish,
        barNameChinese: item.barNameChinese,
        barIcon: item.barIcon,
        hasButton: item.hasButton,
        buttonNames: BUTTON_NAME_LANGS.filter((entry) => !!item[entry.field]).map((entry) => ({ lang: entry.lang, name: item[entry.field] })),
        actionType: item.actionType,
        actionUrl: item.actionUrl,
        targetGroup: item.targetGroup,
        cifCount: (item.cifFiles || []).reduce((total, file) => total + (file.cifCount || 0), 0),
        cifStatus: item.cifProcessingStatus,
        segment: item.segment || [],
        wealthMembership: item.wealthMembership || [],
        conditionSummary: this.summarizeConditions(item.conditions),
        priority: item.priority,
        effStartDate: this.formatDate(item.effectiveStartDate),
        effEndDate: this.formatDate(item.effectiveEndDate) || 'No end date',
        createDate: this.formatDate(item.createDate),
        status: item.enableFlag ? 'Active' : 'Inactive',
        repeatFlag: item.repeatFlag,
        defaultFlag: item.defaultFlag,
      }));
    },

    summarizeConditions(conditions) {
      if (!conditions || conditions.length === 0) return '';
      return conditions
        .map((condition) => {
          const mode = this.getConditionModeName(condition.mode);
          const years = (condition.taxYears || []).join(', ');
          const states = (condition.states || []).map((state) => this.getConditionStateName(state)).join(', ');
          let text = `Tax Planning: ${mode}`;
          if (years) text += ` (${years})`;
          if (states) text += ` — ${states}`;
          return text;
        })
        .join(' | ');
    },

    getConditionModeName(mode) {
      switch (mode) {
        case 'Never':
          return 'Never Create';
        case 'NeverInYears':
          return 'Never Create in Year(s)';
        case 'PendingState':
          return 'Pending in State';
        default:
          return mode || '';
      }
    },

    getConditionStateName(value) {
      const found = this.conditionStateOptions.find((option) => option.valueString === value);
      return found ? found.name : value;
    },

    getTargetGroupName(value) {
      const found = this.targetGroupOptions.find((option) => option.valueString === value);
      return found ? found.name : value;
    },

    getWealthMembershipName(flag) {
      const found = this.wealthMembershipOptions.find((option) => option.valueString === flag);
      return found ? found.name : flag;
    },

    isCifTargetGroup(targetGroup) {
      return targetGroup === 'CIF' || targetGroup === 'ExceptCIF';
    },

    formatDate(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '';
    },

    formatUploadDate(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : '';
    },

    // Short form for the narrow Uploaded column; the full timestamp is on its tooltip.
    formatUploadDay(value) {
      return value ? moment(value).format('DD/MM/YY') : '';
    },

    formatFileSize(bytes) {
      if (!bytes) return '0 B';
      const units = ['B', 'KB', 'MB'];
      let size = bytes;
      let unit = 0;
      while (size >= 1024 && unit < units.length - 1) {
        size /= 1024;
        unit += 1;
      }
      return `${size.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`;
    },

    debouncedSearch(newValue) {
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }
      this.searchDebounceTimer = setTimeout(() => {
        this.isSearch = true;
        this.options.page = 1;
        this.Get();
      }, 500);
    },

    GetOptions() {
      let self = this;
      self.$call.GetBarManagementOptions(
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.segmentOptions = dataResponse.data.segmentOptions || [];
            self.wealthMembershipOptions = dataResponse.data.wealthMembershipOptions || [];
            self.actionTypeOptions = dataResponse.data.actionTypeOptions || [];
            self.targetGroupOptions = dataResponse.data.targetGroupOptions || [];
            self.conditionStateOptions = dataResponse.data.conditionStateOptions || [];
          }
        },
        (errorResource) => {
          console.error('Error getting bar management options:', errorResource);
        }
      );
    },

    // Tax years belong to Tax Config V2 (tax.TaxYearV2) — the same master TaxFormV2.YearID points at and
    // the one BarManagementBAL matches against at runtime. Never read the V1 tax.TaxYear here, and never
    // hardcode a year list. Only active years are offered (#661: with inactive ones the list
    // showed 2 years while Tax Year V2 had 1). The runtime check still reads every year, so a bar saved with a year
    // that was later deactivated keeps working.
    async GetTaxYears() {
      try {
        const years = (await taxConfigV2Api.getYears(false)) || [];
        this.taxYearOptions = [...years]
          .sort((a, b) => (b.year || 0) - (a.year || 0))
          .map((year) => {
            const code = year.taxYearCode || String(year.year || '');
            const name = year.year ? `${year.year} (${year.beYear} BE)` : code;
            return { name, valueString: code };
          });
      } catch (errorResource) {
        console.error('Error getting tax years:', errorResource);
      }
    },

    // "All" is not sent to the API — an empty list already means "do not filter by status".
    getStatusFilter() {
      const filters = [];
      if (this.filters.status.active) filters.push('Active');
      if (this.filters.status.inactive) filters.push('Inactive');
      return filters;
    },

    onStatusAll(checked) {
      if (checked) {
        this.filters.status.active = false;
        this.filters.status.inactive = false;
      } else if (!this.filters.status.active && !this.filters.status.inactive) {
        // Unticking All while nothing else is picked would leave no choice at all — put it back
        this.filters.status.all = true;
      }
    },

    onStatusSpecific() {
      this.filters.status.all = !this.filters.status.active && !this.filters.status.inactive;
    },

    toggleFilter() {
      this.filterDrawer = !this.filterDrawer;
    },

    applyFilters() {
      this.filterDrawer = false;
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },

    clearFilters() {
      this.filters = {
        status: { all: true, active: false, inactive: false },
        targetGroup: [],
        actionType: [],
        segment: [],
        wealthMembership: [],
        effectiveStartDate: null,
        effectiveEndDate: null,
      };
      this.isSearch = true;
      this.options.page = 1;
      this.Get();
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1;
      let yyyy = today1.getFullYear();
      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;
      this.today = dd + '/' + mm + '/' + yyyy;
    },

    // ── dialog ────────────────────────────────────────────────────────────
    openAddDialog() {
      this.isEditMode = false;
      this.editingItemId = null;
      this.addDialog = true;
      this.resetForm();
    },

    Edit(item) {
      let self = this;
      self.isEditMode = true;
      self.editingItemId = item.id;
      self.addDialog = true;

      self.$call.GetBarManagementById(
        item.id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.populateFormWithItem(dataResponse.data);
          }
        },
        (errorResource) => {
          console.error('Error getting bar details:', errorResource);
        }
      );
    },

    populateFormWithItem(item) {
      const condition = this.parseConditions(item.conditions);

      this.formData = {
        name: item.name || '',
        barNameThai: item.barNameThai || '',
        barNameEnglish: item.barNameEnglish || '',
        barNameChinese: item.barNameChinese || '',
        barIcon: item.barIcon || '',
        hasButton: item.hasButton || false,
        buttonNameThai: item.buttonNameThai || '',
        buttonNameEnglish: item.buttonNameEnglish || '',
        buttonNameChinese: item.buttonNameChinese || '',
        actionType: item.actionType || 'None',
        actionUrl: item.actionUrl || '',
        priority: item.priority ?? 1,
        effectiveStartDate: item.effectiveStartDate ? moment(item.effectiveStartDate).format('YYYY-MM-DD') : null,
        effectiveEndDate: item.effectiveEndDate ? moment(item.effectiveEndDate).format('YYYY-MM-DD') : null,
        targetGroup: item.targetGroup || 'All',
        segment: item.segment || [],
        wealthMembership: item.wealthMembership || [],
        cifFiles: [],
        taxConditionEnabled: condition.enabled,
        taxConditionMode: condition.mode,
        taxConditionYears: condition.taxYears,
        taxConditionStates: condition.states,
        enableFlag: item.enableFlag !== undefined ? item.enableFlag : true,
        repeatFlag: item.repeatFlag || false,
        defaultFlag: item.defaultFlag || false,
      };

      if (item.cifFiles && Array.isArray(item.cifFiles)) {
        this.uploadedFiles = item.cifFiles.map((file) => ({
          fileName: file.fileName,
          filePath: file.filePath,
          cifList: file.cifList || [],
          uploadDate: file.uploadDate ? new Date(file.uploadDate) : new Date(),
          fileSize: file.fileSize || 0,
          cifCount: file.cifCount,
        }));
        this.formData.cifFiles = [...this.uploadedFiles];
      } else {
        this.uploadedFiles = [];
        this.formData.cifFiles = [];
      }
    },

    // Unfold conditions[] (the API shape) into the four fields the screen binds to.
    parseConditions(conditions) {
      const found = (conditions || []).find((condition) => condition.type === 'TaxPlanning');
      if (!found) {
        return { enabled: false, mode: 'Never', taxYears: [], states: [] };
      }
      return {
        enabled: true,
        mode: found.mode || 'Never',
        taxYears: found.taxYears || [],
        states: found.states || [],
      };
    },

    // Fold the four screen fields back into conditions[].
    buildConditions() {
      if (!this.formData.taxConditionEnabled) return [];

      const condition = {
        type: 'TaxPlanning',
        mode: this.formData.taxConditionMode,
        taxYears: [],
        states: [],
      };

      // Values belonging to an unselected mode must not tag along. The backend clears them
      // again, but send it clean from here.
      if (this.formData.taxConditionMode !== 'Never') {
        condition.taxYears = this.formData.taxConditionYears || [];
      }
      if (this.formData.taxConditionMode === 'PendingState') {
        condition.states = this.formData.taxConditionStates || [];
      }

      return [condition];
    },

    // Clicking the selected option again clears it; only one can be active at a time.
    // Leaving 'Url' keeps whatever was typed in the box so it is still there if the user
    // switches back; only the "required" error the field may have been showing is cleared,
    // since the rule no longer applies. saveBar() drops the value when the action is not 'Url'.
    setActionType(value) {
      this.formData.actionType = this.formData.actionType === value ? 'None' : value;
      if (this.formData.actionType !== 'Url') {
        this.$nextTick(() => {
          if (this.$refs.actionUrlField) {
            this.$refs.actionUrlField.resetValidation();
          }
        });
      }
    },

    closeAddDialog() {
      this.addDialog = false;
      this.isEditMode = false;
      this.editingItemId = null;
      this.resetForm();
    },

    resetForm() {
      this.formData = EMPTY_FORM();
      this.uploadedFiles = [];
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      if (this.$refs.addForm) {
        this.$refs.addForm.resetValidation();
      }
    },

    async saveBar() {
      let self = this;
      const { valid } = await self.$refs.addForm.validate();
      if (!valid) return;

      // No check for Default vs Target Group here: the screen locks both to "All" while Default
      // is on, so the combination cannot be built. BarManagementBAL.Validate still rejects it for
      // anything that skips the screen.

      // These two cannot be expressed as field rules — they are about a whole panel being empty,
      // and the panel's controls are optional on their own. The API rejects both as well
      // (BarManagementBAL.Validate).
      if (self.formData.targetGroup === 'Persona'
          && (self.formData.segment || []).length === 0
          && (self.formData.wealthMembership || []).length === 0) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'When Target Group is Persona, select at least one Segment or Wealth Membership',
        });
        return;
      }

      // A CIF bar with no file reaches nobody; an Except CIF bar with no file blocks nobody.
      if (self.isCifTargetGroup(self.formData.targetGroup)
          && !(self.formData.cifFiles || []).some((file) => file && file.filePath)) {
        self.$swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Upload at least one CIF file for this Target Group',
        });
        return;
      }

      self.dialog = true;

      let request = {
        name: self.formData.name,
        barNameThai: self.formData.barNameThai,
        barNameEnglish: self.formData.barNameEnglish,
        barNameChinese: self.formData.barNameChinese,
        barIcon: self.formData.barIcon || null,
        hasButton: self.formData.hasButton,
        buttonNameThai: self.formData.hasButton ? self.formData.buttonNameThai : null,
        buttonNameEnglish: self.formData.hasButton ? self.formData.buttonNameEnglish : null,
        buttonNameChinese: self.formData.hasButton ? self.formData.buttonNameChinese : null,
        actionType: self.formData.actionType,
        // Sent as typed even when the action is not 'Url': the value stays parked on the bar
        // so it is still there if URL is ticked again. Nothing reads it while ActionType is
        // not 'Url' (the list chip and the runtime both go through ActionType first).
        actionUrl: self.formData.actionUrl,
        priority: Number(self.formData.priority) || 0,
        effectiveStartDate: self.formData.effectiveStartDate,
        // A cleared date input gives '' — send null (never expires) so the API can bind it
        effectiveEndDate: self.formData.effectiveEndDate || null,
        targetGroup: self.formData.targetGroup,
        segment: [],
        wealthMembership: [],
        cifFiles: [],
        conditions: self.buildConditions(),
        enableFlag: self.formData.enableFlag,
        repeatFlag: self.formData.repeatFlag,
        defaultFlag: self.formData.defaultFlag,
      };

      // Send only the branch the admin actually chose (the backend clears the rest again —
      // see BarManagementBAL.Normalize).
      if (self.formData.targetGroup === 'Persona') {
        request.segment = self.formData.segment || [];
        request.wealthMembership = self.formData.wealthMembership || [];
      } else if (self.isCifTargetGroup(self.formData.targetGroup)) {
        request.cifFiles = self.formData.cifFiles || [];
      }

      const onSuccess = (dataResponse, successText, failText) => {
        if (dataResponse.status === 0) {
          self.$swal.fire({ icon: 'success', title: 'Success', text: successText, timer: 1500, showConfirmButton: false });
          self.closeAddDialog();
          self.Get();
        } else {
          self.$swal.fire({ icon: 'error', title: 'Error', text: dataResponse.message || failText });
        }
        self.dialog = false;
      };

      const onError = (errorResource, failText) => {
        self.dialog = false;
        console.error(failText, errorResource);
        self.$swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorResource?.response?.data?.error || failText,
        });
      };

      if (self.isEditMode) {
        self.$call.UpdateBarManagement(
          self.editingItemId,
          request,
          (dataResponse) => onSuccess(dataResponse, 'Bar updated successfully', 'Failed to update bar'),
          (errorResource) => onError(errorResource, 'Failed to update bar')
        );
      } else {
        self.$call.CreateBarManagement(
          request,
          (dataResponse) => onSuccess(dataResponse, 'Bar created successfully', 'Failed to create bar'),
          (errorResource) => onError(errorResource, 'Failed to create bar')
        );
      }
    },

    DeleteBar(id) {
      let self = this;
      self.$swal
        .fire({
          title: 'Confirm Deletion',
          text: 'Are you sure you want to delete this bar?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.dialog = true;
            self.$call.DeleteBarManagement(
              id,
              (dataResponse) => {
                if (dataResponse.status === 0) {
                  self.$swal.fire({ icon: 'success', title: 'Deleted!', text: 'Bar has been deleted.', timer: 1500, showConfirmButton: false });
                  self.Get();
                } else {
                  self.$swal.fire({ icon: 'error', title: 'Error', text: dataResponse.message || 'Failed to delete bar' });
                }
                self.dialog = false;
              },
              (errorResource) => {
                self.dialog = false;
                console.error('Error deleting bar:', errorResource);
                self.$swal.fire({ icon: 'error', title: 'Error', text: 'Failed to delete bar' });
              }
            );
          }
        });
    },

    // ── CIF file ──────────────────────────────────────────────────────────
    // Reuses Proactive Message's upload/download endpoints — that parser is not tied to any
    // one feature.
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    downloadTemplate() {
      const csvContent = 'cif\n12345678901\n23456789012\n34567890123';
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'cif_template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },

    isSafeImageUrl(url) {
      return !!url && /^(https?:\/\/|data:image\/)/i.test(String(url).trim());
    },

    triggerBarIconUpload() {
      this.$refs.barIconInput.value = '';
      this.$refs.barIconInput.click();
    },

    handleBarIconUpload(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        this.$swal.fire({ icon: 'warning', title: 'Invalid File', text: 'Only image files are allowed' });
        return;
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$swal.fire({ icon: 'warning', title: 'File Too Large', text: 'File size should not exceed 10MB' });
        return;
      }

      const formData = new FormData();
      formData.append('entity', file, file.name);

      this.barIconUploading = true;
      this.$call.UploadBarManagementIcon(
        { entity: formData, USER_CHANNEL: this.$root.User_Id || 'bar_management' },
        (dataResponse) => {
          this.barIconUploading = false;
          if (dataResponse.status === 0 && dataResponse.data) {
            this.formData.barIcon = dataResponse.data;
          } else {
            this.$swal.fire({ icon: 'error', title: 'Error', text: dataResponse.message || 'Failed to upload icon' });
          }
        },
        (errorResource) => {
          console.error('Error uploading bar icon:', errorResource);
          this.barIconUploading = false;
          this.$swal.fire({ icon: 'error', title: 'Error', text: errorResource?.response?.data?.message || 'Failed to upload icon' });
        }
      );
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const maxSize = 5 * 1024 * 1024; // 5MB — matches the endpoint's RequestSizeLimit
      if (file.size > maxSize) {
        this.$swal.fire({ icon: 'warning', title: 'File Too Large', text: 'File size should not exceed 5MB' });
        return;
      }

      if (this.uploadedFiles.some((f) => f.fileName === file.name)) {
        this.$swal.fire({
          icon: 'warning',
          title: 'Duplicate File',
          text: 'A file with this name has already been uploaded. Please rename the file or remove the existing one.',
        });
        return;
      }

      const formData = new FormData();
      formData.append('file', file);

      this.$call.UploadCifFile(
        formData,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            this.uploadedFiles.push({
              fileName: dataResponse.data.fileName || file.name,
              filePath: dataResponse.data.fileUrl,
              cifList: dataResponse.data.cifList || [],
              uploadDate: new Date(),
              fileSize: file.size,
              cifCount: dataResponse.data.cifCount || 0,
            });
            this.formData.cifFiles = [...this.uploadedFiles];

            this.$swal.fire({
              icon: 'success',
              title: 'Success',
              text: `File uploaded successfully. Found ${dataResponse.data.cifCount || 0} CIF codes.`,
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            this.$swal.fire({ icon: 'error', title: 'Error', text: dataResponse.message || 'Failed to upload file' });
          }
          this.$refs.fileInput.value = '';
        },
        (errorResource) => {
          console.error('Error uploading file:', errorResource);
          this.$refs.fileInput.value = '';
          this.$swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorResource?.response?.data?.error || 'Failed to upload file',
          });
        }
      );
    },

    removeCifFile(index) {
      this.uploadedFiles.splice(index, 1);
      this.formData.cifFiles = [...this.uploadedFiles];
    },

    // filePath is a blob URL in a PRIVATE container (ProactiveMessageBAL.UploadCifFileAsync creates
    // it with the default access level), so pointing an <a> straight at it just gets Azure's
    // ResourceNotFound/PublicAccessNotPermitted XML back. The blob has to be streamed through
    // download-cif, which opens it with the storage account key. Same flow as CifListUploader.vue.
    downloadCifFile(file) {
      if (!file || !file.filePath) {
        this.$swal.fire({ icon: 'error', title: 'Error', text: 'No file available for download' });
        return;
      }

      this.$call.DownloadCifFile(
        file.filePath,
        file.fileName,
        (blobData) => {
          const url = URL.createObjectURL(new Blob([blobData]));
          const link = document.createElement('a');
          link.href = url;
          link.download = file.fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        },
        (errorResource) => {
          console.error('Error downloading CIF file:', errorResource);
          this.$swal.fire({ icon: 'error', title: 'Error', text: 'Failed to download file' });
        }
      );
    },
  },
};
</script>

<style scoped>
/* Styles carried over from views/ProactiveMessage.vue so the two screens look like one set.
   Only the styles for things a bar does not have were dropped: CIF background processing,
   Continue Question and Export. */
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}





.btn-layout {
  padding: 14px 24px;

  width: 171px;
  height: 57px;

  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
  border-radius: 16px;
}
.btn-save {
  color: #fff !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;

  width: 120px;
  height: 45px;

  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
  border-radius: 16px;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
}
.btn-close {
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  gap: 10px;

  width: 135px;
  height: 45px;

  border: 1px solid #b4b4b4;
  border-radius: 18px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
}
.btn-filter {
  padding: 6px 8px;
  gap: 8px;

  width: 56px;
  height: 56px;

  background: #4b2869;
  border-radius: 1000px;
}
.search-field {
  border-radius: 30px !important;
  z-index: 9999 !important;
}
.filter-field {
  border-radius: 16px !important;
}

.custom-rounded :deep(.v-field) {
  border-radius: 20px !important;
}

/* Error styling for v-text-field - red background and border */
.custom-rounded.v-input--error :deep(.v-field) {
  background-color: #ffebee !important;
  border-color: #f44336 !important;
}

.custom-rounded.v-input--error :deep(.v-field__outline) {
  --v-field-border-opacity: 1;
}

.custom-rounded.v-input--error :deep(.v-field__outline__start),
.custom-rounded.v-input--error :deep(.v-field__outline__end),
.custom-rounded.v-input--error :deep(.v-field__outline__notch::before),
.custom-rounded.v-input--error :deep(.v-field__outline__notch::after) {
  border-color: #f44336 !important;
}

.custom-rounded :deep(.v-field__outline) {
  border-radius: 20px !important;
}

.custom-rounded :deep(.v-field__field) {
  border-radius: 20px !important;
}

.filter-rounded :deep(.v-field) {
  border-radius: 16px !important;
}

.filter-rounded :deep(.v-field__outline) {
  border-radius: 16px !important;
}

.filter-rounded :deep(.v-field__field) {
  border-radius: 16px !important;
}

.search-field .v-input__control .v-input__slot {
  min-height: 48px !important;
  background: #f5f5f5 !important;
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
}

.search-field .v-input__prepend-inner {
  margin-right: 8px;
  margin-left: 4px;
}

.search-field .v-icon {
  color: #666;
}

.filter-field .v-input__control .v-input__slot {
  min-height: 48px !important;
  background: #f5f5f5 !important;
  box-shadow: none !important;
  border: 1px solid #e0e0e0 !important;
}

.filter-field .v-input__prepend-inner {
  margin-right: 8px;
  margin-left: 4px;
}

.filter-field .v-icon {
  color: #666;
}

:deep(.v-table__wrapper > table > thead) {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important; /* must beat td.sticky-* (z-index: 3) so the thead stacking context sits above the body's sticky cells */
}

:deep(.v-table__wrapper thead tr) {
  background-color: #f5f5f5 !important;
}

:deep(.v-table__wrapper thead th) {
  position: sticky !important;
  top: 0 !important;
  z-index: 4 !important;
  background-color: #f5f5f5 !important;
  color: #333333;
  font-size: 14px;
  font-weight: 600;
  height: 48px;
}

/* More specific selector, in case the rule above does not win */
:deep(.v-data-table-server .v-table thead th) {
  position: sticky !important;
  top: 0 !important;
  z-index: 4 !important;
  background-color: #f5f5f5 !important;
  color: #333333;
  font-size: 14px;
  font-weight: 600;
  height: 48px;
}

/* Applies to every element in the table header */
:deep(.v-data-table-server .v-table thead tr th) {
  background-color: #f5f5f5 !important;
}

/* Table shell */
:deep(.v-data-table) {
  border: 1px solid #e1e1e1;
  border-radius: 24px;
  overflow: clip; /* clip does not create a scroll container, so position:sticky keeps working */
}

:deep(.v-table) {
  border-radius: 24px;
  overflow: clip; /* clip does not create a scroll container, so position:sticky keeps working */
}
/* horizontal scroll ให้ .v-table__wrapper จัดการเท่านั้น — ห้ามตั้ง overflow-x: auto ที่ .v-data-table เพราะจะสร้าง scroll container ซ้อนที่ทำลาย sticky */
.table-container {
  overflow-x: auto;
  max-width: 100%;
  position: relative;
}

/* ===== Sticky columns: แยก td (body) vs th (header) ===== */

/* Body cells - sticky แนวนอนเท่านั้น */
td.sticky-action {
  position: sticky !important;
  right: 0 !important;
  background-color: #fff !important;
  z-index: 3 !important;
}

td.sticky-repeat {
  position: sticky !important;
  right: 12% !important;
  background-color: #fff !important;
  z-index: 3 !important;
}

td.sticky-status {
  position: sticky !important;
  right: 17% !important;
  background-color: #fff !important;
  z-index: 3 !important;
}

/* Header cells - sticky ทั้งแนวนอนและแนวตั้ง, z-index สูงกว่า body */
th.sticky-action {
  position: sticky !important;
  right: 0 !important;
  top: 0 !important;
  background-color: #f5f5f5 !important;
  z-index: 5 !important;
}

th.sticky-repeat {
  position: sticky !important;
  right: 12% !important;
  top: 0 !important;
  background-color: #f5f5f5 !important;
  z-index: 5 !important;
}

th.sticky-status {
  position: sticky !important;
  right: 17% !important;
  top: 0 !important;
  background-color: #f5f5f5 !important;
  z-index: 5 !important;
}

/* ตาราง */
:deep(.my-data-table .v-table__wrapper) {
  overflow-x: auto !important;
}

:deep(.my-data-table table) {
  min-width: 2000px;
}

/* เพิ่ม CSS สำหรับ segment chips */
.data-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  align-items: center;
  max-width: 200px;
  margin: 0 auto;

  /* A chip is 136px wide in a 200px column, so they stack one per line at 40px each
     (32px chip + its ma-1 margins). Cap the cell at five and scroll the rest — a bar targeting
     a dozen segments would otherwise stretch its row far taller than every other row. */
  max-height: 200px;
  overflow-y: auto;
  align-content: flex-start;
}

/* A hairline instead of a real scrollbar: no track, no buttons, just a solid grey line so the
   cell still shows there is more to see without a chunky bar eating into the column. */
.data-container {
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #c4c4c4 transparent;
}

.data-container::-webkit-scrollbar {
  width: 3px;
}

.data-container::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 0;
}

.data-container::-webkit-scrollbar-track,
.data-container::-webkit-scrollbar-corner {
  background: transparent;
}

.data-container::-webkit-scrollbar-button {
  display: none;
}

.data-chip {
  font-size: 12px !important;

  color: #666 !important;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;

  width: 136px;
  height: 32px;

  background-color: #f2f2f2 !important;
  border-radius: 100px;
}

/* ปรับแต่งสีของ v-chip สำหรับ segment */
:deep(.data-chip .v-chip__content) {
  font-size: 11px;
  font-weight: 500;
  padding: 0 8px;
}

/* หากต้องการสีเทาเข้มขึ้น */
:deep(.v-chip.data-chip) {
  background-color: #f2f2f2 !important;
  color: black !important;
}

.icon-active {
  color: #4caf50 !important; /* สีเขียว */
  opacity: 1;
}

.icon-inactive {
  color: #e0e0e0 !important; /* สีเทาอ่อน */
  opacity: 0.5;
}

/* หรือใช้ตัวนี้แทนหากต้องการควบคุมสีมากขึ้น */
:deep(.v-icon.icon-active) {
  color: #4caf50 !important;
}

:deep(.v-icon.icon-inactive) {
  color: #bdbdbd !important;
}

/* Filter Drawer Styles */
.filter-drawer {
  z-index: 9000 !important;
}

.filter-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.filter-header {
  background-color: #fff;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 20px;
  font-weight: 600;
  font-size: 16px;
}

.filter-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.filter-section {
  margin-bottom: 24px;
}

.filter-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.filter-checkbox {
  margin-bottom: 4px;
}

:deep(.filter-checkbox .v-selection-control) {
  min-height: 32px;
}

:deep(.filter-checkbox .v-label) {
  font-size: 14px;
  color: #555;
}



.filter-actions {
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.dialog-header {
  padding: 20px 16px !important;
}

.dialog-title {
  font-size: 1.25rem !important;
  color: #1f1f1f;
}
.dialog-subtitle {
  color: #898989;
}
.icon-background {
  padding: 8px;
  gap: 10px;

  width: 46px;
  height: 46px;

  background: #dee7f3;
  backdrop-filter: blur(2px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 100px;
  box-shadow: none;
}
.dialog-content {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.form-section {
  margin-bottom: 24px;
}
.form-section-bg {
  padding: 16px;
  gap: 24px;
  height: 389px;

  background: #eeeff3;
  border-radius: 16px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

/* Multilingual message display styles */
.message-multilang {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 0;
}

.message-box {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border-left: 3px solid;
  background-color: #f8f9fa;
  transition: all 0.2s ease;
}

.message-box:hover {
  background-color: #f0f1f3;
}

.message-box-thai {
  border-left-color: #1e88e5;
  background-color: #e3f2fd;
}

.message-box-thai:hover {
  background-color: #bbdefb;
}

.message-box-english {
  border-left-color: #43a047;
  background-color: #e8f5e9;
}

.message-box-english:hover {
  background-color: #c8e6c9;
}

.message-box-chinese {
  border-left-color: #e53935;
  background-color: #ffebee;
}

.message-box-chinese:hover {
  background-color: #ffcdd2;
}

.message-lang-header {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 45px;
  flex-shrink: 0;
}

.lang-label {
  font-size: 10px;
  font-weight: 700;
  color: #666;
  text-transform: uppercase;
}


.message-text {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}



.message-input-group {
  margin-bottom: 5px;
}

.language-label {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
}



.dialog-actions {
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
  border-radius: 0 0 16px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
}

.toggle-switches-section {
  display: flex;
  align-items: center;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  height: 40px;
  min-width: 80px;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
}

/* ปรับแต่ง Switch ให้เล็กลง */
:deep(.toggle-switches-section .v-switch) {
  flex: none;
}

:deep(.toggle-switches-section .v-switch .v-selection-control) {
  min-height: 32px;
}

:deep(.toggle-switches-section .v-switch .v-label) {
  font-size: 14px;
  margin-left: 8px;
}

/* Dialog responsive */
@media (max-width: 768px) {
  .dialog-actions {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .toggle-switches-section {
    justify-content: center;
  }

  .action-buttons {
    justify-content: center;
    width: 100%;
  }

  .action-btn {
    flex: 1;
    max-width: 120px;
  }
  .add-bar-dialog {
    margin: 16px;
  }

  .dialog-content {
    padding: 16px;
  }
}

.header-icon-container {
  width: 48px;
  height: 48px;
  margin-right: 12px;
}

.dialog-header-add {
  background: #eeeff3;
}
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-20px);
  max-height: 0;
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  max-height: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 200px;
}

.upload-btn {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 32px;
  gap: 8px;

  width: 167px;
  height: 40px;

  background: rgba(24, 92, 55, 0.1);
  border: 1px solid #185c37;
  border-radius: 8px;

  /* Inside auto layout */
  flex: none;
  order: 3;
  flex-grow: 0;
}
.download-btn {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;

  width: 236px;
  height: 45px;

  background: linear-gradient(90deg, #504897 0%, #4b2667 100%);
  border-radius: 16px;

  color: #fff !important;

  /* Inside auto layout */
  flex: none;
  order: 3;
  flex-grow: 0;
}


/* Fade transition for upload button and file info */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.custom-switch :deep(.v-switch) {
  flex: none;
}

.custom-switch :deep(.v-selection-control) {
  min-height: 32px;
  display: flex;
  align-items: center;
}

.custom-switch :deep(.v-selection-control__wrapper) {
  height: 24px;
  width: 44px;
  margin-right: 1px;
}

.custom-switch :deep(.v-switch__track) {
  height: 24px;
  width: 44px;
  border-radius: 12px;
  background-color: #e0e0e0 !important;
  border: 1px solid #d0d0d0;
  transition: all 0.3s ease;
}

.custom-switch :deep(.v-switch__thumb) {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  transform: translateX(2px);
}

/* Active state */
.custom-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #6366f1 !important;
  border-color: #6366f1;
}

.custom-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  transform: translateX(1px);
  background-color: #fff;
}

/* Label styling */
.custom-switch :deep(.v-label) {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-left: 1px;
}

/* Hover effects */
.custom-switch :deep(.v-switch__track):hover {
  opacity: 0.8;
}

.custom-switch :deep(.v-switch__thumb):hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Focus styles */
.custom-switch :deep(.v-selection-control--focus-visible .v-switch__track) {
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
}

/* Disabled state */
.custom-switch :deep(.v-selection-control--disabled .v-switch__track) {
  /* background-color: #f5f5f5 !important;
  border-color: #e0e0e0 !important; */
  opacity: 0.8;
}

.custom-switch :deep(.v-selection-control--disabled .v-switch__thumb) {
  background-color: #ffffff !important;
  box-shadow: none;
}

.custom-switch :deep(.v-selection-control--disabled .v-label) {
  color: #000000 !important;
}







/* Animation for adding/removing questions */

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modern-table :deep(.v-table__wrapper) {
  /* Fill the screen below the header/filter bar (a fixed px height cut the list to a few rows, since rows carry chips).
     The wrapper stays the scroll container, which keeps the sticky thead working. */
  max-height: calc(100vh - 420px);
  min-height: 300px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper > table > thead) {
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 4;
  background-color: #f5f5f5;
}

.modern-table :deep(.v-table__wrapper thead th.sticky-action),
.modern-table :deep(.v-table__wrapper thead th.sticky-repeat),
.modern-table :deep(.v-table__wrapper thead th.sticky-status) {
  z-index: 5 !important;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
/* ── Bar Management — Add/Edit dialog ────────────────────────────────────── */

/* Palette, radii and shadow of the dialog. They live on the dialog root as custom
   properties so every descendant — Vuetify internals included — can read them
   through var() without repeating the hex codes. */
.add-bar-dialog {
  --purple: #4c2a75;
  --purple-deep: #3d2063;
  --purple-soft: #f1ebf7;
  --border: #e4e6ec;
  --border-strong: #d6d9e1;
  --text-dark: #1e2130;
  --text-mid: #666870;
  --text-label: #454a57;
  --placeholder: #a6aab4;
  --gray-card: #f7f7fa;
  --danger: #d6473c;
  --radius-lg: 16px;
  --radius-md: 12px;
  --radius-sm: 8px;

  /* Column layout so the body scrolls while header and footer stay put. */
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  background: #fff;
  color: var(--text-dark);
}

/* Compounded with .v-card so it outranks Vuetify's own card elevation/radius rules */
.add-bar-dialog.v-card {
  border-radius: 20px !important;
  box-shadow: 0 30px 70px rgba(30, 20, 55, 0.18), 0 4px 14px rgba(30, 20, 55, 0.06) !important;
}

/* Header — title, subtitle and the round close button */
.bm-header {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 26px 28px 18px;
  border-bottom: 1px solid var(--border);
}

/* Lets a long title wrap instead of pushing the close button off the header */
.bm-header-text {
  min-width: 0;
}

.bm-title {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.2px;
  color: var(--text-dark);
  margin-bottom: 5px;
}

.bm-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: var(--text-mid);
}

.bm-close {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text-mid);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}

.bm-close:hover {
  background: var(--gray-card);
}

/* Body — the only scrolling region of the dialog */
.bm-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 24px 28px 8px;
}

.bm-body::-webkit-scrollbar {
  width: 6px;
}

.bm-body::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: 6px;
}

/* Blocks, labels and headers */
.bm-group {
  margin-bottom: 22px;
}

.bm-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-label);
  margin-bottom: 8px;
}

.bm-label-spaced {
  margin-top: 16px;
}

.bm-req {
  color: var(--danger);
  font-size: 11px;
}

.bm-section-header,
.bm-sub-header {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-dark);
  margin-bottom: 10px;
}

.bm-tg-header {
  margin-bottom: 14px;
}

.bm-hint {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-label);
  margin-bottom: 10px;
}

.bm-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* Grey card that groups a section's fields */
.bm-card {
  background: var(--gray-card);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 16px;
}

.bm-lang-field + .bm-lang-field {
  margin-top: 14px;
}

.bm-lang-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-label);
  margin-bottom: 7px;
}

/* Sub-block gated by a checkbox: dimmed and click-through while the box is unticked
   (the inputs inside are separately :disabled so they cannot be reached by keyboard) */
.bm-lang-sub {
  transition: opacity 0.15s;
}

/* Inactive groups (Button Name before its checkbox is ticked, Target URL before the URL action
   is picked). Vuetify already dims a disabled field on its own, so a 0.45 wrapper on top of that
   stacked two dims and left the rows barely readable. Keep the wrapper close to full strength and
   raise Vuetify's own disabled opacity instead — still visibly "off", but legible. */
.bm-lang-sub.is-off {
  opacity: 0.9;
  pointer-events: none;
  --v-disabled-opacity: 0.8;
}

.bm-lang-sub.is-off .bm-lang-label {
  color: var(--text-label);
}

/* Text fields and selects: white, 8px corners, thin grey outline turning purple on focus */
.bm-field :deep(.v-field) {
  border-radius: var(--radius-sm);
  background: #fff;
  font-size: 13.5px;
  color: var(--text-dark);
}

.bm-field :deep(.v-field__outline) {
  --v-field-border-width: 1.5px;
  --v-field-border-opacity: 1;
  color: var(--border);
  border-radius: var(--radius-sm);
}

.bm-field :deep(.v-field--focused .v-field__outline) {
  --v-field-border-width: 1.5px;
  color: var(--purple);
}

.bm-field.v-input--error :deep(.v-field__outline) {
  color: var(--danger);
}

.bm-field :deep(.v-field__input) {
  padding-inline: 14px;
  font-size: 13.5px;
}

.bm-field :deep(input::placeholder) {
  color: var(--placeholder);
  opacity: 1;
}

.bm-field :deep(.v-messages__message) {
  font-size: 11px;
  padding-inline: 2px;
}

.bm-field-narrow {
  max-width: 200px;
}

/* Checkboxes drawn small and tight, matching the mockup's tick rows */
.bm-check :deep(.v-selection-control) {
  min-height: 24px;
}

.bm-check :deep(.v-selection-control__wrapper) {
  width: 28px;
  height: 28px;
}

.bm-check :deep(.v-label) {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-dark);
  opacity: 1;
  margin-left: 2px;
}

.bm-check-strong :deep(.v-label) {
  font-weight: 700;
}

.bm-enable-row {
  margin-bottom: 12px;
}

.bm-action-row {
  display: flex;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
}

.bm-action-detail {
  margin-top: 14px;
}

/* Purple note shown when the Tax Planning action is picked */
.bm-tax-note {
  margin-top: 14px;
  background: var(--purple-soft);
  border: 1px solid #e1d3ee;
  border-radius: var(--radius-sm);
  padding: 10px 13px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--purple-deep);
}

/* Locked on "All" while the bar is the default — greyed the same way a disabled switch is,
   so the two locks on this screen read as the same thing. */
.bm-seg-grid.is-locked {
  opacity: var(--v-disabled-opacity, 0.38);
}

/* Only the tiles stop taking clicks — the grid itself has to keep receiving hover, or the
   tooltip explaining the lock would never open. */
.bm-seg-grid.is-locked .bm-seg-item {
  pointer-events: none;
}

/* Primary Segment — four selectable tiles acting as one radio group */
.bm-seg-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 14px;
}

.bm-seg-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 10px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  background: #fff;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.15s, background 0.15s;
}

.bm-seg-item:hover,
.bm-seg-item:focus-visible {
  border-color: #d9c6ea;
  outline: none;
}

.bm-seg-item.is-selected {
  border-color: var(--purple);
  background: var(--purple-soft);
}

.bm-radio-dot {
  position: relative;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--border-strong);
  transition: border-color 0.15s;
}

.bm-seg-item.is-selected .bm-radio-dot {
  border-color: var(--purple);
}

.bm-seg-item.is-selected .bm-radio-dot::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--purple);
}

.bm-radio-text {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-dark);
}

/* Separates Primary Segment from the refinement conditions */
.bm-dashed-divider {
  border-top: 1px dashed var(--border-strong);
  margin: 18px 0 16px;
}

/* CIF upload / template buttons */
.bm-cif-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

/* !important because Vuetify sizes v-btn from its own size class of equal specificity */
.bm-excel-btn {
  height: 40px !important;
  border-radius: 10px;
  font-size: 12.5px !important;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.bm-excel-upload {
  background: #e8f7ee !important;
  border: 1.5px solid #bfe8cc !important;
  color: #1f7a45 !important;
}

.bm-excel-download {
  background: var(--purple) !important;
  color: #fff !important;
  box-shadow: 0 8px 18px rgba(76, 42, 117, 0.25) !important;
}

/* Uploaded CIF files: the table is wider than the modal, so it scrolls sideways */
.bm-file-table {
  margin-top: 12px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.bm-file-table-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-label);
  background: var(--gray-card);
  border-bottom: 1px solid var(--border);
}

/* table-layout: fixed keeps a long file name from pushing the two narrow columns off the edge —
   the name cell truncates instead of the table growing. */
.bm-file-rows :deep(table) {
  table-layout: fixed;
  width: 100%;
}

.bm-file-rows :deep(th) {
  font-size: 12.5px !important;
  font-weight: 700;
  color: var(--text-label) !important;
  height: 38px !important;
  padding: 0 10px !important;
}

.bm-file-rows :deep(td) {
  padding: 8px 10px !important;
  height: auto !important;
}

/* Extra breathing room between the Uploaded date and the action buttons */
.bm-file-rows :deep(th:last-child),
.bm-file-rows :deep(td:last-child) {
  padding-left: 18px !important;
}

.bm-file-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.bm-file-meta {
  min-width: 0;
}

.bm-file-name {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-dark);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bm-file-sub {
  font-size: 11.5px;
  color: var(--text-mid);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* The two row buttons share 168px, so they still run tighter than Vuetify's x-small default */
.bm-file-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.bm-file-actions :deep(.v-btn) {
  height: 28px !important;
  min-width: 0 !important;
  padding: 0 8px !important;
  font-size: 10.5px !important;
  font-weight: 700;
  letter-spacing: 0;
  border-radius: 6px;
}

/* Refinement conditions — bordered radio rows that reveal their own inputs when picked */
.bm-status-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: opacity 0.15s;
}

.bm-status-list.is-off {
  opacity: 0.45;
  pointer-events: none;
}

.bm-status-item {
  border: 1.5px solid var(--border);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  background: #fff;
  transition: border-color 0.15s, background 0.15s;
}

.bm-status-item.is-selected {
  border-color: var(--purple);
  background: var(--purple-soft);
}

.bm-status-head {
  cursor: pointer;
}

.bm-status-item :deep(.v-selection-control) {
  min-height: 24px;
}

.bm-status-item :deep(.v-label) {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-dark);
  opacity: 1;
}

.bm-status-body {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed var(--border-strong);
}

/* Date fields show the design's 📅 instead of Chrome's built-in glyph.
   The native indicator is not removed — it is made transparent and stretched across the icon's
   corner, so it stays the click target that opens the picker. The 📅 sits on top with
   pointer-events off, letting the click fall straight through to it. */
/* The transparent native indicator is stretched over the WHOLE field, not just the icon corner,
   so clicking anywhere in the box opens the picker. It is positioned against .v-field, which
   Vuetify already sets to position: relative. */
.bm-date-field :deep(input[type='date']::-webkit-calendar-picker-indicator) {
  position: absolute;
  inset: 0;
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  opacity: 0;
  cursor: pointer;
}

/* Match the cursor on the parts the indicator does not literally sit on */
.bm-date-field :deep(.v-field),
.bm-date-field :deep(.v-field__input),
.bm-date-field :deep(input[type='date']) {
  cursor: pointer;
}

.bm-date-field :deep(.v-field__append-inner) {
  align-items: center;
  padding-top: 0;
  pointer-events: none;
}

.bm-cal-ic {
  font-size: 14px;
  line-height: 1;
  color: var(--text-mid);
}

/* Current State: a stacked checkbox list rather than a dropdown */
.bm-checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;
}

.bm-field-error {
  margin-top: 4px;
  font-size: 12px;
  color: var(--danger);
}

/* Footer — toggles on the left, cancel/save on the right */
.bm-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;
  padding: 18px 28px;
  border-top: 1px solid var(--border);
}

.bm-toggles {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
}

/* Wrapper exists so the tooltip has an activator while Enable is held on */
.bm-switch-wrap {
  display: flex;
  align-items: center;
}

/* Locked-ON Enable: still purple and still in the on position, just a lighter purple than an
   active switch so it reads as held rather than switched off. Solid colours, no alpha — these are
   #4C2A75 already flattened over the white footer, so they look identical to the translucent
   version but never let the background show through.
   Vuetify paints both parts from an inline style, so these key off our own `is-locked` class
   (never Vuetify's internal disabled class) and override the shorthand, the longhand and the
   opacity it layers on top of a disabled control. */
.bm-switch-wrap.is-locked :deep(.v-switch__track) {
  background: #cdc3d8 !important;
  background-color: #cdc3d8 !important;
  opacity: 1 !important;
}

.bm-switch-wrap.is-locked :deep(.v-switch__thumb) {
  background: #a695ba !important;
  background-color: #a695ba !important;
  color: #a695ba !important;
  opacity: 1 !important;
}

.bm-switch-wrap.is-locked :deep(.v-selection-control),
.bm-switch-wrap.is-locked :deep(.v-input) {
  opacity: 1 !important;
}

/* The label is the only part left carrying the "locked" signal, so it keeps the muted colour */
.bm-switch-wrap.is-locked :deep(.v-label) {
  color: var(--text-mid) !important;
  opacity: 1 !important;
}


.bm-switch :deep(.v-selection-control) {
  min-height: 24px;
}

.bm-switch :deep(.v-label) {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-label);
  opacity: 1;
  margin-left: 6px;
}

.bm-cta {
  display: flex;
  gap: 10px;
}

/* !important because Vuetify sizes v-btn from its own size class of equal specificity */
.bm-btn {
  height: 42px !important;
  border-radius: 10px;
  font-size: 13px !important;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.bm-btn-cancel {
  background: #fff !important;
  border: 1.5px solid var(--border-strong) !important;
  color: var(--text-mid) !important;
}

.bm-btn-cancel:hover {
  background: var(--gray-card) !important;
}

.bm-btn-save {
  background: var(--purple) !important;
  color: #fff !important;
  box-shadow: 0 8px 18px rgba(76, 42, 117, 0.28) !important;
}

.bm-btn-save:hover {
  background: var(--purple-deep) !important;
}

/* Narrow screens: single-column pairs, two-column tiles, stacked footer */
@media (max-width: 520px) {
  .bm-header,
  .bm-body,
  .bm-footer {
    padding-left: 18px;
    padding-right: 18px;
  }

  .bm-grid-2 {
    grid-template-columns: 1fr;
  }

  .bm-seg-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .bm-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .bm-cta {
    justify-content: flex-end;
  }
}

/* Button Name chips. Unlike the single-value chips in the Segment / Wealth columns these carry a
   TH / EN / CN tag beside the value, so two things have to give: the chip needs a little more room
   than .data-chip's 136px, and the value has to be allowed to shrink — a flex item defaults to
   min-width:auto, which would run it past the chip instead of ellipsising it. The full text is on
   the tooltip either way. */
.bm-btn-name-chip {
  width: 160px;
}

.bm-btn-name-chip :deep(.v-chip__content) {
  overflow: hidden;
  min-width: 0;
}

.bm-btn-name-chip :deep(.v-chip__content) > span:last-child {
  min-width: 0;
}
</style>

<!-- Not scoped on purpose: the Tax Year menu is teleported out of the dialog to <body> and is
     rendered by VSelect's own render function, so it carries neither this component's scope id
     nor the --purple custom property .add-bar-dialog defines. Scoped rules and var() cannot
     reach it; the contentClass on :menu-props tags the overlay so these rules can. -->
<style>
/* Ticked Tax Year rows. mdi-checkbox-marked is a solid square with the tick knocked out of it,
   so colouring the ticked icon purple reads as the mockup's purple box with a white check
   (.check-opt.sel .chk-box in Bar_Management_v2.html). --purple is #4c2a75, repeated literally
   here because the variable is out of reach from outside the dialog. Unticked rows keep
   Vuetify's grey outline, matching the mockup's plain .chk-box. */
.bm-year-menu .v-list-item .v-selection-control--dirty .v-icon {
  color: #4c2a75;
  opacity: 1;
}
</style>
